import { render, staticRenderFns } from "./ServicoSelect.vue?vue&type=template&id=0172fa0a&"
import script from "./ServicoSelect.vue?vue&type=script&lang=js&"
export * from "./ServicoSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports